import './LoginPage.css';
import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fontsource/oswald";
import { signInWithGoogle } from './firebase';


const LoginButton = (props) => {
  return (
    <div>
      <Button variant="secondary" onClick={signInWithGoogle}><i className="fab fa-google"></i>Sign in with Google</Button>
    </div>
  )
}

function LoginPage(props) {

  // originally had this under the banner
  return (
    <div>
        <script src="https://www.gstatic.com/firebasejs/ui/6.0.1/firebase-ui-auth.js"></script>
        <link type="text/css" rel="stylesheet" href="https://www.gstatic.com/firebasejs/ui/6.0.1/firebase-ui-auth.css" />
        <div className="LoginBanner">
          DriveWise
        </div>
          <LoginPanel handleSubmit={props.handleSubmit} />
    </div>
  )
}

function LoginPanel(props) {
  return (
      <div className="Login">
          <h1>Login</h1>
          <div><LoginButton/></div>
          <h4>Or sign in with email and password</h4>
          <Form onSubmit={props.handleSubmit}>
              <div id="login">
                    <label>Email 
                      <input type="email" size="40"/>
                    </label>
              </div>
              <div id="login">
                    <label>Password 
                      <input type="password" size="35"/>
                    </label>
              </div>
              <Button variant="secondary" type="submit">
                  Login
              </Button>
          </Form>
          <h1/>
      </div>
  );
}


/*
function LoginPanel(props) {
    return (
        <div className="Login">
            <h1>Login</h1>
            <Form onSubmit={props.handleSubmit}>
                <div><LoginButton/></div>
                <div id="login">
                      <label>Email 
                        <input type="email" size="40"/>
                      </label>
                </div>
                <div id="login">
                      <label>Password 
                        <input type="password" size="35"/>
                      </label>
                </div>
                <Button variant="secondary" type="submit">
                    Login
                </Button>
            </Form>
            <div id="register">
              <p>New to DriveWise?</p>
              <Button variant="secondary" className="secondary" onClick={props.handleRegister}>Register</Button>
            </div>
        </div>
    );
}
*/



export default LoginPage;